document.addEventListener("alpine:init", function () {
    Alpine.data('admin_credits_management_b2b_x_data', () => ({

        init() {
            this.get_statistics()
            this.get_credit_usage_overtime()
            this.render_chart()
            this.get_monthly_credits_consumed()
        },
        show_id: document.getElementById('qlj-credits-management').dataset.showId,
        show_title: document.getElementById('qlj-credits-management').dataset.showTitle,
        statistics: {
            quota: 0,
            quota_used: 0,
            credits: 0,
            clearbit_credits: 0,
            monthly_credits: 0,
            requests: 0
        },
        credit_usage_overtime: {
            date_range: '7D',
            data: [],
            loading_chart: true
        },
        monthly_credits_consumed: {
            data: []
        },
        ...b2b_statistics,
        ...credit_usage_overtime,
        ...b2b_monthly_credit_consumed,

    }))
})

const credit_usage_overtime = {
    select_date_range(date_range) {
        this.credit_usage_overtime.date_range = date_range;
        this.get_credit_usage_overtime();
    },
    async get_credit_usage_overtime() {
        const api_url = document.getElementById('qlj-credits-management')?.dataset?.apiUrl;

        if (!api_url) {
            console.error("API URL not found");
            return;
        }

        try {
            const response = await fetch(api_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
                },
                body: JSON.stringify({
                    method: 'get_b2b_show_data',
                    show_id: this.show_id,
                    date_range: this.credit_usage_overtime.date_range
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            this.credit_usage_overtime.data = data;
            this.render_chart();

        } catch (error) {
            console.error("Error fetching data:", error);
        }
    },
    render_chart() {
        this.loading_chart = true;

        new Chartkick.LineChart("credit-usage-overtime-chart", this.credit_usage_overtime.data, {
            colors: ["#00b0ff", "#ff6384"],
            xtitle: "Date",
            ytitle: "Credits"
        });

        this.loading_chart = false;
    },
    convertToCSV(data) {
        return data.map(row => row.map(item => `"${item}"`).join(",")).join("\n");
    },
    downloadCSV() {
        const csvContent = this.convertToCSV(this.credit_usage_overtime.data);
        const blob = new Blob([csvContent], {type: "text/csv"});
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = `${this.show_title}_credit_usage_overtime.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        URL.revokeObjectURL(url);
    }
}

const b2b_monthly_credit_consumed = {
    async get_monthly_credits_consumed() {
        const api_url = document.getElementById('qlj-credits-management')?.dataset?.apiUrl;

        if (!api_url) {
            console.error("API URL not found");
            return;
        }

        try {
            const response = await fetch(api_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
                },
                body: JSON.stringify({
                    method: 'get_monthly_show_credits_consumed',
                    show_id: this.show_id
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            console.log('monthly_credits_consumed data: ', data);
            this.monthly_credits_consumed.data = data;
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }
}

const b2b_statistics = {
    async get_statistics() {
        const api_url = document.getElementById('qlj-credits-management')?.dataset?.apiUrl;

        if (!api_url) {
            console.error("API URL not found");
            return;
        }

        try {
            const response = await fetch(api_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
                },
                body: JSON.stringify({
                    method: 'get_b2b_show_statistics',
                    duration: this.credit_usage_overtime.date_range,
                    show_id: this.show_id
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            this.statistics.monthly_credits = data.monthly_credits;
            this.statistics.quota_used = data.quota_used;
            this.statistics.credits = data.credits;
            this.statistics.quota = data.quota;
            this.statistics.clearbit_credits = data.clearbit_credits;
            this.statistics.requests = data.requests;

        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }
}

